import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'check-icon',
  shadow: false
})
export class CheckIcon {
  @Prop() svgStyle: any = {};
  @Prop() width: number = 20;
  @Prop() height: number = 14;
  @Prop() circled: boolean = false;

  render() {
    return this.circled
      ? 
        <svg width={this.width} height={this.height} viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
        </svg>
      :
        <svg
          style={this.svgStyle}
          width={this.width}
          height={this.height}
          viewBox="0 0 25 18"
          enable-background="new 0 0 25 18"
          focusable="false"
          fill="currentColor"
        >
          <slot />
          <polygon points="8.906,14.209 1.897,7.214 0,9.108 8.749,17.844 8.908,18 25,1.896 23.104,0 " />
        </svg>;
  }
}
